import { defineMessages } from 'react-intl';

export default defineMessages({
    sameDescription: {
        id: '_.next_repayment_summary.same_description',
        defaultMessage: 'Your next repayment stays the same'
    },
    reducedDescription: {
        id: '_.next_repayment_summary.reduced_description',
        defaultMessage: 'Compared to your next repayment of {amount}'
    },
    noFurtherRepayments: {
        id: '_.next_repayment_summary.no_further_repayments',
        defaultMessage: 'You have no further repayments after that'
    },
    label: {
        id: '_.next_repayment_summary.label',
        defaultMessage: 'Next repayment'
    }
});
